import { ComponentStyleConfig } from '@chakra-ui/react';

export const PinInput: ComponentStyleConfig = {
  baseStyle: {
    padding: 0,
    margin: 0,
    boxShadow: 'none',
    outline: 'none',
    _hover: {
      boxShadow: 'none',
    },
    _focus: {
      boxShadow: 'none',
    },
  },
  variants: {},
  sizes: {
    sm: {},
    md: {
      fontSize: 'sm',
      width: '40px',
      height: '40px',
    },
    lg: {
      fontSize: 'sm',
      width: '48px',
      height: '48px',
    },
  },
  defaultProps: {
    size: 'lg',
  },
};
